module.exports = __webpack_public_path__ + "static/media/dropdown_icon.fd7ecc80.svg";